import { useEffect, useState } from 'react'

type Props = {
  _content: any
  brandId: number
  eventPayload: {
    question_number: number
  }
}

export const useContentLinks = (props: Props) => {
  const { _content, brandId, eventPayload } = props
  const [content, setContent] = useState(_content)

  const [link, setLink] = useState('')
  const [link2, setLink2] = useState('')

  const replaceContent = (link: string) => {
    setContent((prev: string) => {
      if (typeof _content === 'string') {
        return _content.replace(link, '')
      } else if (_content?.length) {
        return _content[0].replace(link, '')
      }
    })
  }

  useEffect(() => {
    if (_content === undefined) return
    if (brandId === 240) {
      if (eventPayload.question_number === 3) {
        const link = 'https://www.incred.com/grievance.html'
        replaceContent(link)
        setLink(link)
      } else if (eventPayload.question_number === 4) {
        const link = 'www.incred.com'
        replaceContent(link)

        setLink('https://' + link)
      } else if (eventPayload.question_number === 5) {
        const link = 'https://www.incred.com/grievance.html'
        replaceContent(link)
        setLink(link)

        const link2 = 'https://sachet.rbi.org.in/'
        replaceContent(link2)
        setLink2(link2)
      }
    } else if (brandId === 261) {
      if (eventPayload.question_number === 5) {
        const link = 'https://sachet.rbi.org.in/'
        replaceContent(link)
        setLink(link)
      } else if (eventPayload.question_number === 6) {
        const link = 'https://www.hdfcbank.com/personal/need-help/contact-us'
        replaceContent(link)
        setLink(link)
      } else if (eventPayload.question_number === 7) {
        const link =
          'https://www.hdfcbank.com/personal/tools-and-calculators#/Footer'
        replaceContent(link)
        setLink(link)
      } else if (eventPayload.question_number === 8) {
        const link =
          'https://www.hdfcbank.com/personal/borrow/popular-loans/personal-loan'
        replaceContent(link)
        setLink(link)
      } else if (eventPayload.question_number === 9) {
        const link =
          'https://www.hdfcbank.com/personal/borrow/popular-loans/business-loan'
        replaceContent(link)
        setLink(link)
      } else if (eventPayload.question_number === 11) {
        const link =
          'https://www.hdfcbank.com/personal/useful-links/important-messages/product-features-and-policy '
        replaceContent(link)
        setLink(link)
      }
    } else if (brandId === 289) {
      if (eventPayload.question_number === 3) {
        const link = 'https://www.ltfs.com/our-products/personal-loans'
        replaceContent(link)
        setLink(link)
      } else if (eventPayload.question_number === 4) {
        const link = 'https://sachet.rbi.org.in/'
        replaceContent(link)
        setLink(link)
      } else if (eventPayload.question_number === 5) {
        const link = 'https://www.ltfs.com/grievance-redressal'
        replaceContent(link)
        setLink(link)
      }
    } else {
      setContent(_content)
    }
  }, [brandId, _content])

  return { content, link, link2 }
}
